import { Alert as AntAlert } from "antd"
import { AuthFormItem } from "components/atoms/form"
import React from "react"
export const AlertBase = ({
  children,
  ...props
}: React.ComponentProps<typeof AntAlert>) => {
  return (
    <AuthFormItem>
      <AntAlert message={children} {...props}></AntAlert>
    </AuthFormItem>
  )
}

export const SuccessAlert = ({
  children,
  ...props
}: React.ComponentProps<typeof AntAlert>) => {
  return (
    <AlertBase type="success" showIcon {...props}>
      {children}
    </AlertBase>
  )
}

export const ErrorAlert = ({
  children,
  ...props
}: React.ComponentProps<typeof AntAlert>) => {
  return (
    <AlertBase showIcon {...props} type="error">
      {children}
    </AlertBase>
  )
}
